import { Injectable } from '@angular/core';
import { Observable, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ReportSource } from '../../interfaces/configuration/report-source';

@Injectable()

export class ReportSourceService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  all(): Observable<ReportSource[] | boolean> {
    return new Observable<ReportSource[] | boolean>((o: Subscriber<ReportSource[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('instellingen.invoer.sources.index'))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ReportSource[]>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  get(id: number): Observable<ReportSource | boolean> {
    return new Observable<ReportSource | boolean>((o: Subscriber<ReportSource | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('instellingen.invoer.sources.read', {':id': id}))
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<ReportSource>response.data);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  create(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('instellingen.invoer.sources.create'), formData);
  }

  sort(formData: any): Observable<ServerResponse> {
    return this.api.sort(this.apiEndpoints.get('instellingen.invoer.sources.sort'), formData);
  }

  update(id: number, formData: any): Observable<ServerResponse> {
    return this.api.put(this.apiEndpoints.get('instellingen.invoer.sources.update', {':id': id}), formData);
  }

  delete(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.delete(this.apiEndpoints.get('instellingen.invoer.sources.delete', {':id': id}))
        .subscribe((response: ServerResponse): void => {
            if (!this.api.isErrorResponse(response)) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  restore(id: number): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>) => {
      const subscription: Subscription = this.api.post(this.apiEndpoints.get('instellingen.invoer.sources.restore', {':id': id}))
        .subscribe((response: ServerResponse): void => {
            if (!this.api.isErrorResponse(response)) {
              o.next(true);
            } else {
              o.next(false);
            }
          },
          (): void => o.next(false));

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }
}
